import React from "react";
import Card from "@ciq/shared/components/card";
import Checkbox from "@ciq/shared/components/checkbox";
import {Geocoder} from "./map/drawHandlers/geocoder";

export const ALL_OPTIONS = [
  {id: "zones", label: "Zones"},
  {id: "aps", label: "Access Points"},
  {id: "floor_plan", label: "Floor Plan"},
]

export function MapOptions({map, state, onChange, options}) {
  const displayOptions = options || ALL_OPTIONS

  const handleChange = option => {
    if (onChange == null) return
    onChange(option)
  }

  return (
    <div className="map-buttons-options">
      {displayOptions.map(option => <MapOption
        key={option.id}
        label={option.label}
        checked={state[option.id]}
        onChange={() => handleChange(option.id)}
      />)}
      <Geocoder map={map}/>
    </div>
  )
}

function MapOption({label, checked, onChange}) {
  checked = !!checked

  const handleClick = (e) => {
    // Ignore clicks inside the Checkbox wrapper to prevent double-toggling (ENG-6575).
    // The Checkbox's onChange handles all checkbox-originated interactions (mouse + keyboard).
    if (e?.target?.closest?.(".da-checkbox")) return
    onChange()
  }

  return (
    <Card className="map-option" onClick={handleClick}>
      <Checkbox checked={checked} onChange={onChange}/>
      <span>{label}</span>
    </Card>
  )
}
